import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';

$('.common-video-plyr').each(function(){
  var $element = $(this);

  const player = new Plyr($element[0], {
    'controls': ['play-large', 'play', 'progress', 'mute', 'volume'],
    'autoplay': true,
    // 'muted': true,
    // 'volume': 0
  });
});

//console.log('running video_ceb4.js');
// var i = 0; 

// $('.video_ceb4').each(function(){
//   var $element = $(this);
//   var $video = $(this).find('video');
//   var video_aspect_ratio = ($element.attr('data-video-aspect-ratio').length) ? $element.attr('data-video-aspect-ratio') : null;


//   const player = new Plyr($video[i], {
//     'controls': ['play-large', 'play', 'progress', 'mute', 'volume'],
//     'ratio' : video_aspect_ratio,
//      'autoplay': true,
//      'muted': true,
//      'volume': 0
//   });
//   i++
// });